import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { DialogContainer } from 'react-md'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Recaptcha, TextField } from 'components'
import * as actions from 'redux/actions'
import * as routes from 'routes'

import './index.css'

class ForgotPassword extends Component {
  constructor (props) {
    super(props)

    this.goBack = this.goBack.bind(this)
    this.closeDialog = this.closeDialog.bind(this)
  }

  goBack () {
    const { history } = this.props
    history.push(routes.signIn())
  }

  closeDialog () {
    this.goBack()
  }

  render () {
    const { visible, handleSubmit, recaptchaRef } = this.props
    return (
      <DialogContainer
        id='forgot-password-dialog'
        visible={visible}
        onHide={this.closeDialog}
        title='Forgot Password'
        dialogClassName='forgot-password-dialog'
        actions={[{
          onClick: handleSubmit,
          primary: true,
          label: 'Send reset instructions'
        }]}
        defaultVisibleTransitionable
        disableScrollLocking
        portal
      >
        <form onSubmit={handleSubmit}>
          <Field
            id='email'
            name='email'
            label='Email'
            placeholder='Please type your email'
            component={TextField}
          />
          <div className='captcha'>
            <Field
              id='captcha'
              name='captcha'
              component={Recaptcha}
              inputRef={recaptchaRef}
            />
          </div>
          <button type='submit' style={{display: 'none'}} />
        </form>
      </DialogContainer>
    )
  }
}

ForgotPassword.propTypes = {
  sendResetInstructions: PropTypes.func.isRequired
}

const ForgotPasswordForm = reduxForm({ form: 'forgotPassword' })(ForgotPassword)

export default withRouter(connect(null, actions)(ForgotPasswordForm))



// WEBPACK FOOTER //
// ./src/containers/Home/SignIn/ForgotPassword/index.js